import type { ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  icon?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function SectionCard({
  title,
  icon,
  action,
  children,
  className = '',
}: SectionCardProps) {
  return (
    <section
      className={[
        'rounded-lg border border-background-200 bg-background-50 p-4 md:p-5',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="mb-4 flex items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
          {icon && (
            <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className={`${icon} text-sm`}></i>
            </span>
          )}
          {title}
        </h3>
        {action}
      </div>
      {children}
    </section>
  );
}